import config from './_config';
import getContext from './_getContext';

export { config, getContext };
